import { render, staticRenderFns } from "./Supply.vue?vue&type=template&id=07280080&scoped=true&lang=html&"
import script from "./Supply.vue?vue&type=script&lang=js&"
export * from "./Supply.vue?vue&type=script&lang=js&"
import style0 from "./Supply.vue?vue&type=style&index=0&id=07280080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07280080",
  null
  
)

export default component.exports